import React, { Fragment } from "react";
import { graphql } from "gatsby"
import Block from "../../Block";
import { headingToAnchor } from "templates/Blog/utils";
class CoreHeading extends Block {
  render() {
    const { block } = this.props;
    const anchor = headingToAnchor(block);
    const HeadingTag = `h${block.attributes.level}`
    return (
      <Fragment>
        <HeadingTag className="anchor-target" id={anchor}>
          <span
            dangerouslySetInnerHTML={{ __html: block.attributes.content }}
          />
        </HeadingTag>
      </Fragment>
    );
  }
}

export const query = graphql`
  fragment BlogBlockHeading on WpCoreHeadingBlock {
    originalContent
    attributes {
      ... on WpCoreHeadingBlockAttributes {
        align
        anchor
        content
        level
      }
    }
  }
`


class CoreHeadingFactory {
  get type() {
    return "core/heading";
  }

  create(props) {
    return <CoreHeading {...props} />;
  }
}

export default CoreHeadingFactory;
